import React from "react";
import About from "../AboutUs/About";
import Appointment from "../Appointment/Appointment";
import Section from "../Section/Section";
import Categories from "../Categories/Categories";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import FAQ from "../Faqs/FAQ";
import Blog from "../Blog/Blog";
import Testimonials from "../Testimonial/Testimonial";
import Justaclickaway from "../JustaClickaway/Justaclickaway";
import HealthExperts from "../HealthExperts/healthExperts";
import WeAreWithu from "../WeRWithu/WeAreWithu";
import StatsCounter from "../HEalthStatus/StatsCounter";

const Home = () => {
  return (
    <>
      <Section />
      <About />
      <Categories />
      <Appointment />
      <WhyChooseUs />
      <StatsCounter id="dc-stats-bar" />
      <HealthExperts />
      <Justaclickaway />

      <WeAreWithu />
      <FAQ />
      <Testimonials />
      <Blog />
    </>
  );
};

export default Home;
